import SummaryItem from 'components/SummaryItem/SummaryItem'
import {
  getFreeTilesTitle,
  renderPriceAfterDiscount,
} from '../../OrderSummaryUtils'
import { BookSize } from '@mixtiles/web-backend-shared'
import { PRODUCT_TYPES } from 'services/ProductTypeState'

function FreeTilesSummaryItem({
  totalTiles,
  additionalTilePrice,
  paidTiles,
  freeTiles,
  currency,
  tilePriceBeforeDiscount,
  freeTilesData,
  productType,
}) {
  const sizes =
    freeTilesData.tileCreditsData?.flatMap((credit) => credit.sizes) ?? []

  const isBooks =
    sizes.some((size) => size in BookSize) &&
    productType === PRODUCT_TYPES.PHOTO_BOOK
  if (freeTiles && !isBooks) {
    const priceBeforeDiscount =
      tilePriceBeforeDiscount || totalTiles * additionalTilePrice
    if (!paidTiles) {
      return (
        <SummaryItem
          text={getFreeTilesTitle(freeTiles)}
          testId="free-tiles-summary-item"
        >
          {renderPriceAfterDiscount(currency, priceBeforeDiscount, 0)}
        </SummaryItem>
      )
    }
  }
  return null
}

export default FreeTilesSummaryItem
